import * as React from "react";

import { cn } from "@/lib/utils";

export interface EmptyStatePanelProps extends React.HTMLAttributes<HTMLDivElement> {
  children: React.ReactNode;
}

export const EmptyStatePanel = React.forwardRef<HTMLDivElement, EmptyStatePanelProps>(
  ({ children, className, ...props }, ref) => {
    return (
      <div
        ref={ref}
        className={cn(
          "rounded-lg border border-dashed border-border bg-muted/30 px-4 py-8 text-center text-sm text-foreground/80",
          className
        )}
        {...props}
      >
        {children}
      </div>
    );
  }
);

EmptyStatePanel.displayName = "EmptyStatePanel";
